import GradeList from "@/controllers/grade/grade-list.js";
import CONFIG from "@/assets/js/config.custom.js";
import Select2Multiple from 'v-select2-multiple-component';
import axios from "axios";

export default {
  extends: GradeList,
  components: {
    Select2Multiple
  },

  data() {
    return {
      inputData: {
        division: null
      }
    };
  },

  computed: {
    divisionOptions() {
      return Object.entries(CONFIG.DIVISION).map(([id, text]) => ({
        id: parseInt(id),
        text: text
      }));
    }
  },

  methods: {
    ...GradeList.methods,

    reset() {
      this.search_grade_name = null;
      this.inputData.division = null;
      this.isLoading = true;
      this.getGrade();
      this.isSearched = false;
    },

    search(page = 1) {
      this.isLoading = true;
      this.searchedData = { 
        grade_name: this.search_grade_name,
        division: this.inputData.division
      };
      this.isSearched = true;
      
      const params = {};

      if (this.search_grade_name && this.search_grade_name.trim() !== '') {
        params.grade_name = this.search_grade_name;
      }
      
      if (this.inputData.division) {
        params.division = this.inputData.division;
      }
      
      axios.get('grade/search?page=' + page, {
        params: params
      })
        .then((res) => {
          this.gradeData = res.data;
          this.isLoading = false;
        }).catch((error) => {
          if (error.response && error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    getDivisionLabel(division) {
      if (!division) return '-';
      
      const found = this.divisionOptions.find(opt => opt.id === division);
      return found ? found.text : division;
    }
  }
};
